import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Slider } from '@material-ui/core';
import NgpField from '../../form/NgpField';
import { RowFlexLayout } from '../../layout';
import { useStyles } from './SyslogStyles';

export default function SyslogSlider({ fieldName, label, valueToStringMapping = {}, sliderParams, initialValue }) {
    const classes = useStyles();
    const { control, errors } = useFormContext();
    const [sliderSelectionText, setSliderSelectionText] = useState(valueToStringMapping[initialValue] || '');

    const handleSliderChange = (value) => {
        setSliderSelectionText(valueToStringMapping[value] || '');
    };

    return (
        <NgpField errors={errors} fieldName={fieldName}>
            <RowFlexLayout vCenter>
                <div className={classes.syslogSliderLabel}>{label}</div>
                <div className={classes.syslogSliderContainer}>
                    <Controller
                        control={control}
                        name={fieldName}
                        render={({ value, onChange }) => (
                            <Slider
                                value={value}
                                onChange={(e, sliderValue) => {
                                    onChange(sliderValue);
                                    handleSliderChange(sliderValue);
                                }}
                                {...sliderParams}
                            />
                        )}
                    />
                </div>
                <div className={classes.syslogSliderSelectionText}>{sliderSelectionText}</div>
            </RowFlexLayout>
        </NgpField>
    );
}
